import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";

interface U2000RequireRoleProps {
  allowedRoles: string[];
  /** BL-0339 — refuse aussi si `auth.user.organizationId` est absent (ex. U3148). */
  requireOrganizationId?: boolean;
}

const U2000RequireRole: React.FC<U2000RequireRoleProps> = ({ allowedRoles, requireOrganizationId = false }) => {
  const { auth } = useU2000AuthContext();
  const location = useLocation();

  const roles: string[] = auth.securityTags || [];
  const hasRole = roles.some((role) => allowedRoles?.includes(role));
  const hasOrganizationId = Boolean(auth.user?.organizationId);
  const allowed = hasRole && (!requireOrganizationId || hasOrganizationId);

  return allowed ? <Outlet /> : <Navigate to="/unauthorized" state={{ from: location.pathname }} />;
};

export default U2000RequireRole;
